/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Question/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Question({
  children,
  viewPath = "/DesignSystem/Question",
  marginBottom = 10,
  marginTop = 20,
  text = "What is the dental plan the patient is using?",
  textAlign = "left"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Question.Question"
  data-view-path={viewPath}
 style={{'--mb-1-Z1iwBUS': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mt-2-Z1iwBUS': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ta-3-Z1iwBUS': textAlign}}
 className={`views-text ${styles.Question1}`}
>
{text}
</span>
{children}
</React.Fragment>)
}